import {
  REFRESH_USER_FACILITIES,
  SELECT_FACILITY,
  SET_VIEW_FACILITY,
  FACILITY_CUSTOMERID,
  FACILITY_CUSTOMERNAME,
} from './constants'

export const SetCustomerType = (selectFacility) => (dispatch) => {
  dispatch({
    type: SELECT_FACILITY,
    payload: selectFacility,
  })
}
export const SetViewFacility = (setViewFacility) => (dispatch) => {
  dispatch({
    type: SET_VIEW_FACILITY,
    payload: setViewFacility,
  })
}
export const setCustomerData = (customerId) => (dispatch) => {
  dispatch({
    type: FACILITY_CUSTOMERID,
    payload: customerId,
  })
}
export const setCustomerName = (customerName) => (dispatch) => {
  dispatch({
    type: FACILITY_CUSTOMERNAME,
    payload: customerName,
  })
}

export const RefreshUserFacilitiesList =
  (refreshFacilitiesList) => (dispatch) => {
    dispatch({
      type: REFRESH_USER_FACILITIES,
      payload: refreshFacilitiesList,
    })
  }
